const AREA_GROUPS = [
  {
    id: '1109',
    areaName: 'ตลาดหอมกระเทียม',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1110',
    areaName: 'อาคารตัดแต่งสินค้า',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1111',
    areaName: 'ตลาดผักปรุงรส',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1112',
    areaName: 'ตลาดผักทั่วไป',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1113',
    areaName: 'ตลาดผักพื้นบ้าน ผักคัดบรรจุ',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1114',
    areaName: 'ตลาดพืชไร่',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1115',
    areaName: 'ตลาดสด',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1116',
    areaName: 'อาคารรถผัก',
    subGroups: [
      {
        code: '0201',
        name: 'ผู้ขายท้ายรถ (อาคารรถผักมีจุดจอดประจำ)'
      },
    ]
  },
  {
    id: '1117',
    areaName: 'อาคารแปรรูปสินค้าตลาดสด',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1118',
    areaName: 'อาคารแปรรูปสินค้า ซอย1_1',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1119',
    areaName: 'โรงน้ำแข็ง',
    subGroups: [
      {
        code: '0901',
        name: 'ผู้รับสิทธิขายน้ำแข็ง'
      },
    ]
  },
  {
    id: '1120',
    areaName: 'ตลาดทุเรียน ส้มโอ กล้วย ขนุน มะละกอ',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1123',
    areaName: 'ตลาดส้ม',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1124',
    areaName: 'ตลาดผลไม้รวม',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1125',
    areaName: 'ตลาดสับปะรด',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1126',
    areaName: 'ตลาดมะม่วง',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1128',
    areaName: 'ตลาดดอกไม้ใหม่',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1129',
    areaName: 'ตลาดผักทั่วไป 2',
    subGroups: [],
  },
  {
    id: '1311',
    areaName: 'แผงอาหารจุดอื่นๆ',
    subGroups: [
      {
        code: '0104',
        name: 'แผงอาหาร'
      },
    ]
  },
  {
    id: '1314',
    areaName: 'แผงอาหารอาคารรถผัก',
    subGroups: [
      {
        code: '0104',
        name: 'แผงอาหาร'
      },
    ]
  },
  {
    id: '1315',
    areaName: 'แผงอาหารตลาดมะม่วง',
    subGroups: [
      {
        code: '0104',
        name: 'แผงอาหาร'
      },
    ]
  },
  {
    id: '1316',
    areaName: 'แผงอาหารตลาดผลไม้รวม',
    subGroups: [
      {
        code: '0104',
        name: 'แผงอาหาร'
      },
    ]
  },
  {
    id: '1317',
    areaName: 'แผงอาหารลานจอดรถ 4',
    subGroups: [
      {
        code: '0104',
        name: 'แผงอาหาร'
      },
    ]
  },
  {
    id: '1318',
    areaName: 'แผงอาหารลานพุทธสถาน',
    subGroups: [
      {
        code: '0104',
        name: 'แผงอาหาร'
      },
    ]
  },
  {
    id: '1407',
    areaName: 'แผงเบ็ดเตล็ด',
    subGroups: [
      {
        code: '0108',
        name: 'แผงเบ็ดเตล็ด'
      },
    ]
  },
  {
    id: '1408',
    areaName: 'แผงเบ็ดเตล็ด-วางถังและอุปกรณ์',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1409',
    areaName: 'ตลาดผักต่างประเทศ 2',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1410',
    areaName: 'แผงเบ็ดเตล็ดอาคารตลาดรถผัก',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1411',
    areaName: 'แผงผลไม้ต่างประเทศ',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1412',
    areaName: 'ตลาดผักต่างประเทศ 1',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1413',
    areaName: 'แผงค้าแฟลตชมพู',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1414',
    areaName: 'แผงแตงโม',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1415',
    areaName: 'แผงปลาร้า ของดอง',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1416',
    areaName: 'ตลาดปลา อาหารทะเล',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1417',
    areaName: 'จุดนัดพบ Meeting Point',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1418',
    areaName: 'ตลาดขนม อาหารแห้ง-แช่แข็ง',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1420',
    areaName: 'แผงเนื้อสัตว์อนามัย',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1421',
    areaName: 'แผงโมเดิร์นเฟรช',
    subGroups: []
  },
  {
    id: '1422',
    areaName: 'แผงเบ็ดเตล็ดตลาดสด',
    subGroups: []
  },
  {
    id: '1423',
    areaName: 'แผงข้าวสาร',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1424',
    areaName: 'แผงผักต่างประเทศ3(อาคารพาณิชย์ 358/85-89)',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1601',
    areaName: 'ช่องว่างระหว่างอาคารโครงการ 1',
    subGroups: [
      {
        code: '0101',
        name: 'แผงค้า'
      },
    ]
  },
  {
    id: '1602',
    areaName: 'ช่องว่างระหว่างอาคารโครงการ 2',
    subGroups: []
  },
  {
    id: '1603',
    areaName: 'ช่องว่างระหว่างอาคารโครงการ 3',
    subGroups: []
  },
  {
    id: '1604',
    areaName: 'ช่องว่างระหว่างอาคารโครงการ 4',
    subGroups: []
  },
  {
    id: '1701',
    areaName: 'ร้านสะดวกซื้อ เขต 3',
    subGroups: [
      {
        code: '0105',
        name: 'ซุ้มน้ำอัดลม'
      },
    ]
  },
  {
    id: '1702',
    areaName: 'ร้านถุงพลาสติก เขต 3',
    subGroups: [
      {
        code: '0106',
        name: 'ซุ้มพลาสติก'
      },
    ]
  },
  {
    id: '1703',
    areaName: 'ร้านหน้าห้องน้ำ เขต 3',
    subGroups: [
      {
        code: '0105',
        name: 'ซุ้มน้ำอัดลม'
      },
    ]
  },
  {
    id: '1704',
    areaName: 'ร้านสะดวกซื้อ เขต 2',
    subGroups: [
      {
        code: '0105',
        name: 'ซุ้มน้ำอัดลม'
      },
    ]
  },
  {
    id: '1705',
    areaName: 'ร้านถุงพลาสติก เขต 2',
    subGroups: [
      {
        code: '0106',
        name: 'ซุ้มพลาสติก'
      },
    ]
  },
  {
    id: '1706',
    areaName: 'ร้านขายอาหาร',
    subGroups: [
      {
        code: '0104',
        name: 'แผงอาหาร'
      },
    ]
  },
  {
    id: '2201',
    areaName: 'อาคารห้องเย็น 1',
    subGroups: [
      {
        code: '0401',
        name: 'เช่าเหมาห้อง'
      },
    ]
  },
  {
    id: '2202',
    areaName: 'อาคารห้องเย็น 2',
    subGroups: [
      {
        code: '0401',
        name: 'เช่าเหมาห้อง'
      },
    ]
  },
  {
    id: '2203',
    areaName: 'อาคารห้องเย็น 3',
    subGroups: [
      {
        code: '0401',
        name: 'เช่าเหมาห้อง'
      },
    ]
  },
  {
    id: '2204',
    areaName: 'อาคารห้องเย็น 4',
    subGroups: [
      {
        code: '0401',
        name: 'เช่าเหมาห้อง'
      },
    ]
  },
  {
    id: '2208',
    areaName: 'อาคารห้องเย็น 5',
    subGroups: [
      {
        code: '0401',
        name: 'เช่าเหมาห้อง'
      },
    ]
  },
  {
    id: '2209',
    areaName: 'อาคารห้องเย็น 6',
    subGroups: [
      {
        code: '0401',
        name: 'เช่าเหมาห้อง'
      },
    ]
  },
  {
    id: '2211',
    areaName: 'อาคารห้องเย็น 7',
    subGroups: []
  },
  {
    id: '3101',
    areaName: 'อาคารพาณิชย์ เขต 1',
    subGroups: [
      {
        code: '1202',
        name: 'อาคารพาณิชย์'
      },
    ]
  },
  {
    id: '3201',
    areaName: 'อาคารพาณิชย์ เขต 2',
    subGroups: [
      {
        code: '0103',
        name: 'ผู้เช่าอาคารพาณิชย์'
      },
    ]
  },
  {
    id: '3301',
    areaName: 'อาคารพาณิชย์ หมู่บ้าน',
    subGroups: [
      {
        code: '1203',
        name: 'หอพัก'
      },
    ]
  },
  {
    id: '3401',
    areaName: 'อาคารพาณิชย์ เขต 3',
    subGroups: [
      {
        code: '0103',
        name: 'ผู้เช่าอาคารพาณิชย์'
      },
    ]
  },
  {
    id: '4144',
    areaName: 'ศูนย์แรงงาน (ตลาดผักพื้นบ้าน)',
    subGroups: [
      {
        code: '0502',
        name: 'ผู้เช่าที่ดิน/สำนักงาน'
      },
    ]
  },
  {
    id: '6110',
    areaName: 'ที่ดินซ.6-7 ล็อค ค.420 ตรว.(ให้เช่า-เกษตรอินทรีย์)',
    subGroups: [
      {
        code: '0502',
        name: 'ผู้เช่าที่ดิน/สำนักงาน'
      },
    ]
  },
  {
    id: '7101',
    areaName: 'บ้านเช่าเลขที่ 355/1029',
    subGroups: [
      {
        code: '0501',
        name: 'ผู้เช่าอาคารที่พักอาศัย'
      },
    ]
  },
  {
    id: '7108',
    areaName: 'อาคาร D',
    subGroups: [
      {
        code: '0501',
        name: 'ผู้เช่าอาคารที่พักอาศัย'
      },
    ]
  },
  {
    id: '7109',
    areaName: 'อาคาร E',
    subGroups: [
      {
        code: '0501',
        name: 'ผู้เช่าอาคารที่พักอาศัย'
      },
    ]
  },
  {
    id: '7110',
    areaName: 'อาคาร F',
    subGroups: [
      {
        code: '0501',
        name: 'ผู้เช่าอาคารที่พักอาศัย'
      },
    ]
  },
  {
    id: '7111',
    areaName: 'อาคาร A',
    subGroups: [
      {
        code: '0501',
        name: 'ผู้เช่าอาคารที่พักอาศัย'
      },
    ]
  },
  {
    id: '7112',
    areaName: 'อาคาร B',
    subGroups: [
      {
        code: '0501',
        name: 'ผู้เช่าอาคารที่พักอาศัย'
      },
    ]
  },
  {
    id: '7113',
    areaName: 'อาคาร C',
    subGroups: [
      {
        code: '0501',
        name: 'ผู้เช่าอาคารที่พักอาศัย'
      },
    ]
  },
  {
    id: '7114',
    areaName: 'อาคาร G',
    subGroups: [
      {
        code: '0501',
        name: 'ผู้เช่าอาคารที่พักอาศัย'
      },
    ]
  },
  {
    id: '7202',
    areaName: 'แฟลตชมพู',
    subGroups: [
      {
        code: '0501',
        name: 'ผู้เช่าอาคารที่พักอาศัย'
      },
    ]
  },
  {
    id: '7203',
    areaName: 'แฟลตดอนเมือง',
    subGroups: []
  },
  {
    id: '7301',
    areaName: 'บ้านพักอาศัยหมู่บ้านพัฒนา',
    subGroups: [
      {
        code: '1201',
        name: 'บ้านพักอาศัย'
      },
    ]
  },
  {
    id: '9101',
    areaName: 'รถจักรยานยนต์',
    subGroups: [
      {
        code: '0801',
        name: 'ผู้บริการรถจักรยานยนต์'
      },
    ]
  },
  {
    id: '9102',
    areaName: 'รถรับจ้าง',
    subGroups: [
      {
        code: '0802',
        name: 'ผู้บริการรถเต็นท์'
      },
    ]
  },
  {
    id: '9103',
    areaName: 'รถแท็กซี่',
    subGroups: [
      {
        code: '0803',
        name: 'ผู้บริการแท๊กซี่'
      },
    ]
  },
  {
    id: '9104',
    areaName: 'รถตระกร้า',
    subGroups: [
      {
        code: '0804',
        name: 'ผู้บริการรถตะกร้า'
      },
    ]
  },
  {
    id: '9105',
    areaName: 'รถร่วมบริการขนส่งสินค้าสี่่มุมเมืองออนไลน์',
    subGroups: []
  },
  {
    id: '9203',
    areaName: 'แรงงานเสื้อแดง',
    subGroups: [
      {
        code: '0702',
        name: 'แรงงานส่งสินค้า (แดง ส้ม)'
      },
    ]
  },
  {
    id: '9204',
    areaName: 'แรงงานรถเข็นยาวส่งผลไม้ (เสื้อเหลือง)',
    subGroups: [
      {
        code: '0702',
        name: 'แรงงานส่งสินค้า (แดง ส้ม)'
      },
    ]
  },
  {
    id: '9207',
    areaName: 'แรงงานเสื้อส้ม',
    subGroups: [
      {
        code: '0702',
        name: 'แรงงานส่งสินค้า (แดง ส้ม)'
      },
    ]
  },
  {
    id: '9301',
    areaName: 'ผู้ขายรถเข็นหาบเร่รายเดือน',
    subGroups: [
      {
        code: '0301',
        name: 'ผู้เข็นเร่'
      },
    ]
  },
  {
    id: '9402',
    areaName: 'สัมปทานเช่าร้านน้ำแข็ง',
    subGroups: [
      {
        code: '0901',
        name: 'ผู้รับสิทธิขายน้ำแข็ง'
      },
    ]
  },
  {
    id: '9403',
    areaName: 'ค่าผ่านทาง',
    subGroups: [
      {
        code: '0903',
        name: 'ผู้ได้รับสิทธิธุรกิจเสริมอื่นๆ'
      },
    ]
  },
  {
    id: '9406',
    areaName: 'ร่มและรถเข็น',
    subGroups: [
      {
        code: '0903',
        name: 'ผู้ได้รับสิทธิธุรกิจเสริมอื่นๆ'
      },
    ]
  },
  {
    id: '9602',
    areaName: 'ธุรกิจเสริมอื่นๆ',
    subGroups: [
      {
        code: '0903',
        name: 'ผู้ได้รับสิทธิธุรกิจเสริมอื่นๆ'
      },
    ]
  },
  {
    id: '9802',
    areaName: 'ส่วนกลางตลาด (ค่าสิทธิอื่นๆ)',
    subGroups: []
  },
  {
    id: '9405',
    areaName: 'สัมปทานน้ำดื่ม',
    subGroups: [
      {
        code: '0902',
        name: 'ผู้รับสิทธิขายน้ำอัดลม'
      },
    ]
  },
  {
    id: '9407',
    areaName: 'สัมปทานน้ำอัดลม',
    subGroups: [
      {
        code: '0902',
        name: 'ผู้รับสิทธิขายน้ำอัดลม'
      },
    ]
  },
];

export default { AREA_GROUPS };
